import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/billing')({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings', search: { tab: 'billing' } });
  },
});
